<section class="banner-section">
    <picture>
        @if (mobileUrl || layoutMobileUrl) {
        <source [srcset]="mobileUrl ? mobileUrl : layoutMobileUrl" media="(max-width: 640px)" />
        } @else {
        <source [srcset]="desktopUrl" media="(max-width: 640px)" />
        }

        <img [src]="desktopUrl" [alt]="banner()?.title" />
    </picture>
</section>